declare global {
	interface Window {
		__env: any;
	}
}

const env = window.__env || {};

const signUpSignIn = env.B2C_SIGNIN_POLICY || '';

export const environment = {
	production: env.PRODUCTION || false,
	apiUrl: env.API_URL || '',
	apiUrlImportacion: env.API_URL_IMPORTACION || '',
	apiUrlTrazabilidad: env.API_URL_TRAZABILIDAD || '',
	apiUrlFuentesInformacion: env.API_URL_FUENTES || '',
	oAuth2Scopes: env.OAUTH2_SCOPE || '',
	redirectUri: env.REDIRECT_URI || '',
	googleMapsApiKey: env.GOOGLE_MAPS_API_KEY || '',
	signUpSignIn: signUpSignIn,
	resetPassword: signUpSignIn,
	authority: `${env.AUTHORITY_URL}/${signUpSignIn}`,
	authorityDomain: env.AUTHORITY_DOMAIN || '',
	clientId: env.CLIENT_ID || '',
	apimSubscriptionKey: env.APIM_SUBSCRIPTION_KEY || '',
	apimSubscriptionValue: env.APIM_SUBSCRIPTION_VALUE || '',
	tokenRenewalOffsetSeconds: env.TOKEN_RENEWAL_OFFSET_SECONDS || 180
};
